import { sameNodePosition, } from "../../components/markdown/utils";
import { cn } from "../../lib";
import React, { memo } from "react";
export const LinkBlock = memo(({ href, children, className, onClick, rel: providedRel, target: providedTarget, title, }) => {
    const target = providedTarget !== null && providedTarget !== void 0 ? providedTarget : "_blank";
    const rel = providedRel !== null && providedRel !== void 0 ? providedRel : (target === "_blank" ? "noopener noreferrer" : undefined);
    return (React.createElement("a", { href: href, title: title !== null && title !== void 0 ? title : href, target: target, rel: rel, onClick: onClick, className: cn("s-break-all s-font-semibold s-transition-all s-duration-200 s-ease-in-out hover:s-underline", "s-text-highlight dark:s-text-highlight-night", "hover:s-text-highlight-400 dark:hover:s-text-highlight-400-night", "active:s-text-highlight-dark dark:active:s-text-highlight-dark-night", className) }, children));
}, (prev, next) => sameNodePosition(prev.node, next.node) &&
    prev.href === next.href &&
    prev.rel === next.rel &&
    prev.target === next.target &&
    prev.title === next.title &&
    prev.className === next.className &&
    prev.onClick === next.onClick);
LinkBlock.displayName = "LinkBlock";
//# sourceMappingURL=LinkBlock.js.map